import React, { useState } from "react";
import { FiCheckSquare } from "react-icons/fi";
import LoadingOverlay from "../components/LoadingOverlay";
import TravelExpenseApprovalSection from "../components/travelExpense/TravelExpenseApprovalSection";

const TravelExpenseApprovalPage = () => {
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [loading, setLoading] = useState(false);

  return (
    <div className="px-4 sm:px-6 py-6 relative min-h-screen dark:bg-gray-950 transition-colors duration-300">
      <LoadingOverlay loading={loading} />

      <div className="mb-6">
        <div className="flex items-start gap-3 mb-3">
          <div className="w-11 h-11 rounded-2xl bg-yellow-50 dark:bg-yellow-900/30 flex items-center justify-center text-yellow-700 dark:text-yellow-300">
            <FiCheckSquare size={20} />
          </div>
          <div>
            <h1 className="text-[26px] font-semibold text-gray-900 dark:text-yellow-400 leading-tight">
              Travel Expense Approvals
            </h1>
            <p className="text-gray-500 dark:text-gray-400 text-sm mt-1">
              ตรวจสอบ อนุมัติ หรือปฏิเสธรายการเบิกค่าเดินทางที่รอดำเนินการ
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white dark:bg-gray-900 border border-gray-100 dark:border-gray-700 rounded-xl shadow-sm p-5 transition-colors duration-300">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-6">
          <div>
            <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-200">
              รายการรออนุมัติ
            </h2>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
              เลือกปีที่ต้องการตรวจสอบ แล้วค้นหารายการที่ต้องอนุมัติ
            </p>
          </div>

          <select
            value={selectedYear}
            onChange={(e) => setSelectedYear(Number(e.target.value))}
            className="border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 rounded-md px-3 py-2 text-sm text-gray-700 dark:text-gray-200 focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400 transition-all w-full sm:w-28"
          >
            {[currentYear + 1, currentYear, currentYear - 1, currentYear - 2].map(
              (year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              )
            )}
          </select>
        </div>

        <TravelExpenseApprovalSection
          selectedYear={selectedYear}
          setPageLoading={setLoading}
        />
      </div>
    </div>
  );
};

export default TravelExpenseApprovalPage;